import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgModel } from '@angular/forms';
import { AlertService } from '../services/alert-service.service';
import { EmployeeService } from '../services/employee.service';
import { CustomerService } from '../services/customer.service';
import { AuthenticationService } from '../services/authentication.service';
import { FormChangeService } from '../services/form-change.service';
import { VariablesPayeService } from '../services/variable-paye-service';

@Component({
  selector: 'app-form-min-add-data-paies',
  templateUrl: './form-min-add-data-paies.component.html',
  styleUrls: ['./form-min-add-data-paies.component.scss']
})
export class FormMinAddDataPaiesComponent implements OnInit, OnDestroy {
  sites: {};
  customers;
  selectedSite: any[];
  subscription : Subscription;
  selectAll: boolean;
  searchText: string;
  searchTextCust: string;
  numeroMin: number;
  numeroMax: number;
  model: NgModel;
  countAnnonces;
  @Input()
  withPeriod: boolean;
  period: any;
  selectedPeriod: string;
  periodList: any[];
  constructor(
    private alertService: AlertService,
    private employeeService: EmployeeService,
    private customerService: CustomerService,
    private authenSer: AuthenticationService,
    private formService: FormChangeService,
    public variablePaieService: VariablesPayeService,
    public router: Router) {
  }
  ngOnDestroy(): void {
    // this.subscription.unsubscribe();
  }


  ngOnInit() {
    this.getSiteFromBackend()
        .subscribe(
          dataSite => {
            let tmp = dataSite as Array<any>;
            this.sites = tmp;
          }
          , error => {

            let msg = error['error'] ? error['error']['error'] + ': ' : error;
            this.alertService.error(msg);
            // this.formService.raiseVariablePaieListEvent({});
            this.formService.raiseAddDataPaieListEvent({});
          });
          this.rechercher();
          this.subscribeReloadSearchRequest();
  }

  subscribeReloadSearchRequest() {
    this.subscription = this.formService.reloadAddDataPaieRequest.subscribe(
      (param) => {
        this.rechercher();
      });
  }

  clearForm() {
    this.rechercher();
  }

  rechercher() {
    let filter = this.getFilter();
    this.callEmployeeBackend()
    .subscribe(
      data => {
        let tmp = data as Array<any>;
        if (tmp && tmp.length > 0) {
          if (this.selectedSite && this.selectedSite.length > 0) {
            tmp = tmp.filter( emp =>{
              return this.selectedSite.includes(emp.siteId);
            })
          }
            if (filter) {
                tmp = this.findTextInPlaces(tmp, filter);
              }
          }
         this.formService.raiseAddDataPaieListEvent(tmp);

      }
      , error => {

        let msg = error['error'] ? error['error']['error'] + ': ' : error;
        this.alertService.error(msg);
        this.formService.raiseAddDataPaieListEvent({});

      });

  }


  // appel du backend pour retirer la liste des employées avec en paramêtre l'utilisateur connecté. Filtre sans objet.
  callEmployeeBackend() {
    return this.employeeService.getMyEmployeesByFilter(this.authenSer.getUserLoggedIn());
  }

  getSiteFromBackend() {
    let currentUser = this.authenSer.getUserLoggedIn();
    return this.employeeService.getSites(currentUser);
  }

  onChange() {
    this.rechercher();
  }

  private findTextInPlaces(employees, text) {
    text = text?text.split(' '):'';
    if(text){
      return employees.filter(function (item) {
        return text.every(function (el) {
          return item['name'].toUpperCase().indexOf(el.toUpperCase()) > -1
            || item['firstname'].toUpperCase().indexOf(el.toUpperCase()) > -1;
        });
      });
  }
  }
  private getFilter() {
    let filter = this.searchText ? this.searchText : null;
    return filter;
  }

}
